// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Admin, DataProvider, Resource } from "react-admin";
import {checkTimeAuth} from './auth-provider/ra-auth-jwt';
import "./App.scss";
import Login from "./Login";
import { UserIdentificationCreate } from "./UserIdentification/UserIdentificationCreate";
import { UserIdentificationEdit } from "./UserIdentification/UserIdentificationEdit";
import { UserIdentificationList } from "./UserIdentification/UserIdentificationList";
import {
  createUserIdentification,
  getUserIdentification,
  getUserIdentificationList,
} from "./UserIdentification/index";
import { jwtAuthProvider } from "./auth-provider/ra-auth-jwt";
import { CampaignList } from "./campaign-price/CampaignList";
import { getCampaignPricesList } from "./campaign-price/index";
import customRoutes from "./customRoutes";
import buildGraphQLProvider from "./data-provider/graphqlDataProvider";
import { ListDiscount } from "./discount/DiscountList";
import { getDiscount, getDiscountList } from "./discount/index";
import { OrderList } from "./order/OrderList";
import { OrderShow } from "./order/OrderShow";
import { getCustomers, getOrder, getOrderList } from "./order/index";
import Dashboard from "./pages/Dashboard";
import PaymentManagerDashboard from "./pages/PaymentManagerDashboard";
import { UpdatePaymentGatewayManager } from "./PaymentGatewayManager/UpdatePaymentGatewayManager";
import  {UpdateSnappPayment} from  './snapp-payment/UpdateSnappPayment';
import  {UpdateDigipayPayment} from  './digipay-payment/UpdateDigipayPayment';
import { SwitchGateWay } from "./switch-gateway/SwitchGateWay";
import { PartnerDiscountSmsLogList } from "./partnerDiscountSmsLog/PartnerDiscountSmsLogList";
import {UpdateTaraPayment} from './tara-payment/UpdateTaraPayment';
import {CreateGroupLimooCard} from './groupLimooCard/createGroupLimooCard';
import {ListReserveManagement} from './reserveManagement/listReserveManagement';
import {
  getPartnerDiscountSmsLogCount,
  getPartnerDiscountSmsLogList,
} from "./partnerDiscountSmsLog/index";
import { ProductCreate } from "./product/ProductCreate";
import { ProductEdit } from "./product/ProductEdit";
import { ProductList } from "./product/ProductList";
import { ProductShow } from "./product/ProductShow";
import {
  createProduct,
  getProduct,
  getProductList,
  updateProduct,
} from "./product/index";
import { TransferForm } from "./financialTransfer/TransferForm";
import { ReturnForm } from "./financialReturn/ReturnForm";
import {EditDietType}from './editDietType/editDietType';
import {EditLimooPlustDietType} from './manage-diet-info/editLimooPlustDietType';
import {ManageDietInfo} from './manage-diet-info/manageinfo';
import {ManageRelatedOfFiles} from './manageRelatedOfFiles/manageRelatedOfFiles';
// import { transfer_form } from "./financialTransfer/index";
// import { return_form } from "./financialReturn/index";
import {TaraSendBulk} from './taraSendBulk/TaraSendBulk'; 
import { theme } from "./theme/theme";
import { DiscountShow } from "./discount/DiscountShow"; 
import ManageReseller from "./manage-reseller/manage-reseller";
import { CreateReseller } from "./manage-reseller/create-reseller";
import { UpdateResellerWallet } from "./manage-reseller/update-reseller-wallet";
import { NewBetterMeCampaignPopups } from "./newbetterme-campaign-popups";
import { canEditIntegrationConfigs } from "./newbetterme-campaign-popups/permissions";

const App = (): React.ReactElement => {
  const [dataProvider, setDataProvider] = useState<DataProvider | null>(null);
  const [permissions, setPermissions] = useState<string[]>([]);
  async function fetchPermission() {
    try {
      const permissions = await jwtAuthProvider.getPermissions(true);
      setPermissions(permissions);
    } catch (error) {
      // console.error(error);
    }
  }
  useEffect(() => {
    fetchPermission();
    checkTimeAuth()
  }, []);

  const integrationConfigResources = (permissionsList: string[]) =>
    canEditIntegrationConfigs(permissionsList)
      ? [
          <Resource
            key="NewBetterMeCampaignPopups"
            name="marketing/newbetterme-campaign-popups"
            options={{ label: "پاپ‌آپ NewBetterMe" }}
            list={NewBetterMeCampaignPopups}
          />,
        ]
      : [];

  const renderWithPermission = (permissionsList: string[]) => {
    if (permissionsList.includes("limoome_shop.admin")) {
      return [
        ...integrationConfigResources(permissionsList),
        <Resource
          name="Product"
          options={{ label: "محصولات" }}
          list={ProductList}
          edit={ProductEdit}
          create={ProductCreate}
          show={ProductShow}
        />,
        <Resource
          name="Order"
          options={{ label: "سفارشات" }}
          list={OrderList}
          show={OrderShow}
        />,
        <Resource
          name="Discount"
          options={{ label: "تخفیف‌ها" }}
          list={ListDiscount}
          show={DiscountShow}
        />,
        <Resource
          name="CampaignPrice"
          options={{ label: "کمپین" }}
          list={CampaignList}
        />,
        <Resource
          name="PartnerDiscountSmsLog"
          options={{ label: "تاریخچه ارسال پیامک" }}
          list={PartnerDiscountSmsLogList}
        />,
        <Resource
          name="UserIdentificationLinkExcel"
          options={{ label: "لینک‌های اختصاصی" }}
          list={UserIdentificationList}
          create={UserIdentificationCreate}
          edit={UserIdentificationEdit}
        />,
        <Resource
        name="CreateGroupLimooCard"
        options={{ label: "ایجاد لیموکارت گروهی" }}
        list={CreateGroupLimooCard}
      />,
      <Resource
      name="TaraSendBulk"
      options={{ label: "ارسال اطلاعات کاربران به تارا  " }}
      list={TaraSendBulk}
    />,
      
      ];
    } else if (canEditIntegrationConfigs(permissionsList)) {
      return integrationConfigResources(permissionsList);
    } else if (
      permissionsList.includes("limoome_shop.partner_bundle_support")
    ) {
      return [
        <Resource
          name="PartnerDiscountSmsLog"
          options={{ label: "تاریخچه ارسال پیامک" }}
          list={PartnerDiscountSmsLogList}
        />,
      ];
    } else if( permissionsList.includes("limoome_shop.payment_manager")) {
      return [
        
      <Resource
      name="ManageDietInfo"
      options={{ label: "مدیریت رژیم" }}
      list={ManageDietInfo}
    />,
      
        <Resource
        name="financialTransfer"
        options={{ label: "انتقال پرداخت " }}
        list={TransferForm}
      />,
      <Resource
      name="financialReturn"
      options={{ label: " عودت وجه " }}
      list={ReturnForm}
    />,
    <Resource
    name="SnappPayment"
    options={{ label: "  پرداخت های اسنپ  " }}
    list={UpdateSnappPayment}
  />,

  <Resource
  name="PaymentGatewayManager"
  options={{ label: "  توکن های درگاه" }}
  list={UpdatePaymentGatewayManager}
/>,
  <Resource
  name="SwitchGateWay"
  options={{ label: "  سوییچ درگاه آنلاین   " }}
  list={SwitchGateWay}
/>,
        <Resource
        name="DigipayPayment"
        options={{ label: "  پرداخت های دیجی پی  " }}
        list={UpdateDigipayPayment}
        />,
        <Resource
        name="TaraGateWay"
        options={{ label: " پرداختی های تارا " }}
        list={UpdateTaraPayment}
        />,
        <Resource
        name="ListReserveManagement"
        options={{ label: " مدیریت رژیم رزرو " }}
        list={ListReserveManagement}
        />,
        <Resource
        name="ManageRelatedOfFiles"
        options={{ label: " مدیریت فایل های وابسته " }}
        list={ManageRelatedOfFiles}
        />,
        
      ];
    }
    else if(permissionsList.includes("limoome_shop.reseller_manager")) {
      return [
        <Resource
          name="CreateReseller"
          options={{ label: "افزودن مربی"}}
          list={CreateReseller}
        />,
        <Resource
          name="UpdateResellerWallet"
          options={{ label: "شارژ کیف پول مربی" }}
          list={UpdateResellerWallet}
        />
    ]
    } else {
      return [<></>];
    }
  };

  useEffect(() => {
    buildGraphQLProvider
      .then((provider: any) => {
        const myDataProvider = {
          ...provider,
          getList: (resource: any, params: any) => {
            if (resource === "Product") {
              let productsResult: Array<any> = [];
              let productTotal = 0;
              return new Promise((resolve, reject) => {
                getProductList(params)
                  .then((result) => {
                    productsResult = result.data.products;
                    let especialProduct = productsResult.find(
                      (p) => p.id === "diet-1"
                    );
                    if (especialProduct)
                      console.log(
                        "get product especialProduct: ",
                        especialProduct
                      );
                    productTotal = Number.parseInt(
                      result.data._productsMeta.count
                    );
                    resolve({
                      data: productsResult,
                      total: productTotal,
                    });
                  })
                  .catch(() => {
                    reject();
                  });
              });
            } else if (resource === "Order") {
              let ordersResult: Array<any> = [];
              let orderTotal = 0;
              return getOrderList(params).then((result) => {
                ordersResult = result.data.orders;
                orderTotal = Number.parseInt(result.data.total.count);
                return new Promise((resolve, reject) => {
                  getCustomers(ordersResult).then((res) => {
                    resolve({
                      data: res,
                      total: orderTotal,
                    });
                  });
                });
              });
            } else if (resource === "CampaignPrice") {
              return new Promise((resolve, reject) => {
                getCampaignPricesList(params).then((result) => {
                  let campaignPricesResult =
                    result.data.campaignPriceGroupBy.map((cpgh: any) => {
                      return {
                        ...cpgh,
                        id: cpgh.utmCampaign,
                      };
                    });
                  let campaignPricesTotal = Number.parseInt(
                    campaignPricesResult.length
                  );
                  resolve({
                    data: campaignPricesResult,
                    total: campaignPricesTotal,
                  });
                });
              });
            } else if (resource === "Discount") {
              return new Promise((resolve, reject) => {
                getDiscountList(params).then((result) => {
                  let discountsResult = result.data.items;
                  let discountsTotal = Number.parseInt(result.data.total.count);
                  resolve({
                    data: discountsResult,
                    total: discountsTotal,
                  });
                });
              });
            } else if (resource === "PartnerDiscountSmsLog") {
              return new Promise((resolve, reject) => {
                getPartnerDiscountSmsLogList(params)
                  .then(async (res: any) => {
                    let smsLogResult = res.data.partnerDiscountSmsLogs;
                    let smsLogTotal = await getPartnerDiscountSmsLogCount(
                      params
                    );
                    resolve({
                      data: smsLogResult,
                      total: smsLogTotal,
                    });
                  })
                  .catch(() => {
                    reject();
                  });
              });
            } else if (resource === "UserIdentificationLinkExcel") {
              return new Promise((resolve, reject) => {
                getUserIdentificationList(params)
                  .then(async (res: any) => {
                    let userIdentificationResult =
                      res.data.UserIdentificationLinkExcels;
                    let userIdentificationCount =
                      res.data._UserIdentificationLinkExcelsMeta.count;
                    resolve({
                      data: userIdentificationResult,
                      total: userIdentificationCount,
                    });
                  })
                  .catch(() => {
                    reject();
                  });
              });
            } else {
              return provider.getList(resource, params);
            }
          },
          getOne: (resource: any, params: any) => {
            if (resource === "Order") {
              return new Promise((resolve, reject) => {
                getOrder(params)
                  .then((result) => {
                    resolve({
                      data: result.data.order,
                    });
                  })
                  .catch(() => {
                    reject();
                  });
              });
            } else if (resource === "Product") {
              return new Promise((resolve, reject) => {
                getProduct(params)
                  .then((result) => {
                    let productResult = result.data.product;
                    productResult = {
                      ...productResult,
                      meta: {
                        ...productResult.meta,
                        tags: productResult.meta.tags.map((t: any) => {
                          return { label: t };
                        }),
                      },
                    };
                    resolve({
                      data: productResult,
                    });
                  })
                  .catch(() => {
                    reject();
                  });
              });
            }  else if (resource === "Discount") { 
              return new Promise((resolve, reject) => {
                getDiscount(params)
                  .then((result) => {
                    let discountResult = result.data.discount;  
                    discountResult = {
                      ...discountResult,
                      usedDiscountsCount: discountResult.usedDiscounts.length > 0 ?discountResult.usedDiscounts?.filter((usedDiscount => usedDiscount.status === 'Used')).length : 0
                    }
                    resolve({
                      data: discountResult,
                    });
                  })
                  .catch(() => {
                    reject();
                  });
              });
            } else if (resource === "UserIdentificationLinkExcel") {
              return new Promise((resolve, reject) => {
                getUserIdentification(params)
                  .then((result) => {
                    let data = {
                      ...result.data.UserIdentificationLinkExcel,
                      expirationDate:
                        result.data.UserIdentificationLinkExcel.expirationDate.substring(
                          0,
                          10
                        ),
                    };

                    resolve({
                      data: data,
                    });
                  })
                  .catch(() => {
                    reject();
                  });
              });
            } else {
              return provider.getOne(resource, params);
            }
          },
          create: (resource: any, params: any) => {
            if (resource === "Product") {
              return new Promise((resolve, reject) => {
                createProduct(params)
                  .then((result: any) => {
                    resolve({
                      data: result.data.createProduct,
                    });
                  })
                  .catch(() => {
                    reject();
                  });
              });
            } else if (resource === "UserIdentificationLinkExcel") {
              return new Promise((resolve, reject) => {
                createUserIdentification(params)
                  .then((result: any) => {
                    console.log("createUserIdentification result: ", result);
                    resolve({
                      data: result.data,
                    });
                  })
                  .catch(() => {
                    reject();
                  });
              });
            } else {
              return provider.create(resource, params);
            }
          },
          update: (resource: any, params: any) => {
            if (resource === "Product") {
              return new Promise((resolve, reject) => {
                updateProduct(params)
                  .then((result: any) => {
                    resolve({
                      data: result.data.updateProduct,
                    });
                  })
                  .catch(() => {
                    reject();
                  });
              });
            } else {
              return provider.update(resource, params);
            }
          },
        };
        setDataProvider(() => myDataProvider);
      })
      .catch((error: any) => {
        console.log(error);
      });
  }, []);
  if (!dataProvider) {
    return <div>Loading</div>;
  }

  function renderDashboard(permissions = []) {
    if (
      permissions.includes("limoome_shop.admin") ||
      permissions.includes("limoome_shop.payment_manager")
    ) {
      return <Dashboard />;
    } else {
      return null;
    }
  }

  return (
    <div className="App">
      <Admin
        title={"پنل مدیریت لیمومی‌شاپ"}
        dataProvider={dataProvider}
        authProvider={jwtAuthProvider}
        theme={theme}
        dashboard={({ permissions }) => renderDashboard(permissions)}
        loginPage={Login}
        customRoutes={customRoutes}
      >
        {(permissions) => renderWithPermission(permissions)}
      </Admin>
    </div>
  );
};

export default App;
